import React, { useState } from 'react';
import API_URL from '../../config';
import authService from '../../services/authService';
import './ConsentGate.css';

// P1 — LGPD. Tela bloqueante de aceite de consentimento. App.jsx a
// renderiza, no lugar do app, quando GET /api/lgpd/consent/status indica
// que o tenant ainda não aceitou os termos vigentes. O aceite é
// registrado em POST /api/lgpd/consent/accept.

function ConsentGate({ user, onAccepted, onDecline }) {
  const [marcado, setMarcado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const aceitar = async () => {
    if (!marcado || enviando) return;
    setErro('');
    setEnviando(true);
    try {
      const resp = await fetch(`${API_URL}/api/lgpd/consent/accept`, {
        method: 'POST',
        headers: authService.getAuthHeaders(),
      });
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      onAccepted();
    } catch (error) {
      setErro(
        'Não foi possível registrar o aceite. Verifique sua conexão e tente novamente.'
      );
      setEnviando(false);
    }
  };

  return (
    <div className="consent-overlay">
      <div className="consent-card">
        <div className="consent-brand">
          <img
            src="/qaasa-icon-light.png"
            alt="Qaa.sa"
            className="consent-logo"
          />
          <span className="consent-brand-nome">Qaa.sa</span>
        </div>

        <h1 className="consent-titulo">Termos de Uso e Privacidade</h1>
        <p className="consent-texto">
          Para continuar usando o Qaa.sa, precisamos do seu aceite dos Termos
          de Uso e da Política de Privacidade. Os documentos descrevem como
          tratamos os dados pessoais e de qualidade da sua empresa, em
          conformidade com a LGPD (Lei nº 13.709/2018).
        </p>

        <ul className="consent-pontos">
          <li>
            Os dados são usados para operar a gestão de Não Conformidades e
            gerar as análises de qualidade.
          </li>
          <li>
            Você pode exercer os direitos do titular (acesso, correção,
            eliminação) a qualquer momento.
          </li>
          <li>
            O contato do Encarregado de Proteção de Dados (DPO) está nos
            documentos abaixo.
          </li>
        </ul>

        <div className="consent-links">
          <a href="/privacidade" target="_blank" rel="noopener noreferrer">
            Ler a Política de Privacidade <span className="material-symbols-outlined" style={{ fontSize: '15px', verticalAlign: 'text-bottom' }}>open_in_new</span>
          </a>
          <a href="/termos" target="_blank" rel="noopener noreferrer">
            Ler os Termos de Uso <span className="material-symbols-outlined" style={{ fontSize: '15px', verticalAlign: 'text-bottom' }}>open_in_new</span>
          </a>
        </div>

        <label className="consent-checkbox">
          <input
            type="checkbox"
            checked={marcado}
            onChange={(e) => setMarcado(e.target.checked)}
            disabled={enviando}
          />
          <span>
            Li e concordo com a Política de Privacidade e os Termos de Uso da
            Qaa.sa.
          </span>
        </label>

        {erro && <div className="consent-erro">{erro}</div>}

        <button
          type="button"
          className="consent-btn-aceitar"
          onClick={aceitar}
          disabled={!marcado || enviando}
        >
          {enviando ? 'Registrando…' : 'Aceitar e continuar'}
        </button>

        <button
          type="button"
          className="consent-btn-sair"
          onClick={onDecline}
          disabled={enviando}
        >
          Sair
        </button>

        {user && user.email && (
          <p className="consent-usuario">Conectado como {user.email}</p>
        )}
      </div>
    </div>
  );
}

export default ConsentGate;
